/**
 * Shared analytics events that are common across multiple views
 */
export const SHARED_EVENTS = {
  LOADED: "Loaded",
  ERROR: "Error",
  EMPTY_STATE: "Empty State",
  // Fired when a user drills into an asset view from a graph line or a factor table row.
  DRILLDOWN_OPENED: "Drilldown Opened",
} as const
